import { render, staticRenderFns } from "./Invite.vue?vue&type=template&id=4be10f35&scoped=true"
import script from "./Invite.vue?vue&type=script&lang=js"
export * from "./Invite.vue?vue&type=script&lang=js"
import style0 from "./Invite.vue?vue&type=style&index=0&id=4be10f35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be10f35",
  null
  
)

export default component.exports